import axios from 'axios'
import Utils from '@lib/util'
import AppConfigService from '@src/services/config'

export const state = {
  currentUser: getSavedState('auth.currentUser') || {
    user: {
      fullName: "-",
      userName: "-"
    }
  },
}

export const mutations = {
  SET_CURRENT_USER(state, newValue) {
    saveState('auth.currentUser', newValue)
    state.currentUser = newValue
    setDefaultAuthHeaders(state)
  },
}

export const getters = {
  // Whether the user is currently logged in.
  loggedIn(state) {

    if(state.currentUser != null && state.currentUser.user != null && Utils.abp.session.userId != null){
      return true;
    } 

    return false;
  },
}

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  init({ state, dispatch }) {
    setDefaultAuthHeaders(state)
    dispatch('validate')
  },

  // Logs in the current user.
  logIn({ commit, dispatch, getters }, { username, password } = {}) {
    // if (getters.loggedIn) return dispatch('validate')

    return axios
      .post(
        AppConfigService.config.apiBaseUrl + '/api/TokenAuth/Authenticate',
        { userNameOrEmailAddress: username, password }
      )
      .then((response) => {
        const user = response.data.result

        commit('SET_CURRENT_USER', Object.assign({}, user))

        var tokenExpireDate = new Date(
          new Date().getTime() + 1000 * response.data.result.expireInSeconds
        )
        Utils.abp.auth.setToken(
          response.data.result.accessToken,
          tokenExpireDate
        )
        Utils.abp.utils.setCookieValue(
          'enc_auth_token',
          response.data.result.encryptedAccessToken,
          tokenExpireDate,
          Utils.abp.appPath
        )

        return user
      })
  },

  // Logs out the current user.
  logOut({ commit }) {
    commit('SET_CURRENT_USER', null)
    localStorage.clear()
    sessionStorage.clear()
  },

  // Validates the current user's token and refreshes it
  // with new data from the API.
  validate({ commit, state }) {
    return Promise.resolve(null)
    // if (!state.currentUser) return Promise.resolve(null)
    // return (
    //   axios
    //     .get('/api/session')
    //     // .then((response) => {
    //     //   const user = response.data
    //     //   // commit('SET_CURRENT_USER', user)
    //     //   return user
    //     // })
    //     .catch((error) => {
    //       if (error.response && error.response.status === 401) {
    //         // commit('SET_CURRENT_USER', null)
    //       }
    //       return null
    //     })
    // )
  },
}

// ===
// Private helpers
// ===

function getSavedState(key) {

  var userFormLS = window.localStorage.getItem(key);

  if(userFormLS != null) {
    return JSON.parse(window.localStorage.getItem(key))
  } else {
    return null;
  }

}

function saveState(key, state) {
  window.localStorage.setItem(key, JSON.stringify(state))
}

function setDefaultAuthHeaders(state) {
  // axios.defaults.headers.common.Authorization = state.currentUser
  //   ? state.currentUser.accessToken
  //   : ''
}
